<section class="samples-workspace">
  <header class="samples-toolbar">
    <div><h1>Cupping samples</h1><p class="sample-hint">Prepare samples for roasting, review results, and follow up on rejected arrivals.</p></div>
    @if(SelectedOfferSample){<button mat-button class="btn-bg-blue" (click)="BackToList()"><mat-icon>arrow_back</mat-icon>Back to samples</button>}
    @else {<button mat-button class="btn-bg-green" (click)="OpenOfferSample()"><mat-icon>add</mat-icon>New offer sample</button>}
  </header>
  @if(!SelectedOfferSample){
    <div class="sample-views" role="group" aria-label="Sample views">
      <button mat-button [class.active]="!ShowCompletedSamples" (click)="setSampleView('queue')">To prepare ({{samples.length}})</button>
      <button mat-button [class.active]="ShowCompletedSamples && !ShowRejectedArrivals" (click)="setSampleView('completed')">Cupped samples ({{completedSamples.length}})</button>
      <button mat-button [class.active]="ShowRejectedArrivals" (click)="setSampleView('rejected')">Rejected arrivals ({{rejectedArrivals.length}})</button>
    </div>
    @if(ShowRejectedArrivals){<p class="sample-hint">Latest rejected arrival under Replace terms. Review the reason and coordinate replacement with the supplier and Inbound.</p>}
    <div class="samples-table"><rms-table [data]="ShowRejectedArrivals ? rejectedArrivals : (ShowCompletedSamples ? completedSamples : samples)" [columns]="ShowCompletedSamples ? completedSampleColumns : offerSampleColumns" [clickableRow]="true" (onRowClick)="selectSample($event)"></rms-table></div>
  }
  <div class="sample-detail" [hidden]="!SelectedOfferSample">
    @if(!!SelectedOfferSample){
    <div class="sample-detail-grid">
      <fieldset class="rms-fieldset" style="flex:1; min-width:0; margin:0">
        <legend>Sample</legend>
        <div style="display:flex; flex-direction:column; gap:12px; width:100%">
          <div style="display:flex; align-items:center; gap:10px">
            <h1 class="sample-title">
              {{SelectedOfferSample.InventoryID}} - {{SelectedOfferSample.InventoryLabelName}} @if(SelectedOfferSample.InventoryCreated){(Inventory Created)}
              -
              <span style="color:red; font-weight:bolder; font-style:italic">
                {{SelectedOfferSample.IsOfferSample ? 'Offer Sample' : getSampleTypeLabel(SelectedOfferSample)}} {{SelectedOfferSample.Recupping ? '(Recup)' : ''}}
                @if(ShowCompletedSamples){
                 -
                <span [ngStyle]="{'color': SelectedOfferSample.WasApproved ? 'green' : 'red'}">{{SelectedOfferSample.Recup ? 'Recup requested' : SelectedOfferSample.SampleStatus}}</span>
                }
              </span>
            </h1>
            <div style="display:flex; gap:10px; align-items:center; margin-left:auto">
              @if(SelectedOfferSample.IsOfferSample && !SelectedOfferSample.InventoryCreated){
              <button mat-icon-button (click)="OpenOfferSample(SelectedOfferSample)"><mat-icon>edit</mat-icon></button>
              }
            </div> 
          </div>
          <h2 style="margin:0">{{'Supplier: ' + SelectedOfferSample.SupplierLabelName}}</h2>
          <form #SampleForm="ngForm" style="display:flex; flex-direction:column; gap:12px">
            <div class="sample-fields">

              <rms-input type="percent" label="Moisture Reading" [(ngModel)]="SelectedOfferSample.MoistureReading" name="moistureReading" [required]="true" [disabled]="ShowCompletedSamples"></rms-input>
              <rms-number label="Water Activity" [(ngModel)]="SelectedOfferSample.WaterActivity" name="waterTestScore" [disabled]="ShowCompletedSamples"></rms-number>
              <rms-date label="Date Roasted" [(ngModel)]="SelectedOfferSample.DateRoasted" name="dateRoasted" [disabled]="ShowCompletedSamples"></rms-date>
            </div>
            <div style="width:100%">
              @if(!ShowCompletedSamples){
              <button mat-button class="btn-bg-green" type="button" (click)="onSaveSample()" [disabled]="!SampleForm.form.valid || saving">Update Sample</button>
              }
            </div>

          </form>
          @if(ShowCompletedSamples && SelectedOfferSample.SampleApprovalTerm){
          <div style="display:flex; align-items:center; gap:12px">
            <div [ngStyle]="{'background': getSasTermStyle(SelectedOfferSample).text + '1A'}"
                 style="width:44px; height:44px; border-radius:50%; display:flex; align-items:center; justify-content:center; flex-shrink:0">
              <mat-icon [ngStyle]="{'color': getSasTermStyle(SelectedOfferSample).text}">verified</mat-icon>
            </div>
            <div>
              <div style="font-size:12px; font-weight:bold; color:#475569; margin-bottom:2px">SAS Terms</div>
              <div [ngStyle]="{'color': getSasTermStyle(SelectedOfferSample).text}" style="font-size:16px; font-weight:700">{{SelectedOfferSample.SampleApprovalTerm}}</div>
            </div>
          </div>
          }
          @if(ShowCompletedSamples && !SelectedOfferSample.IsOfferSample && SelectedOfferSample.WasApproved === false && !SelectedOfferSample.Recup){
          <div>
            <h3 style="margin-bottom:10px">Actions</h3>
            <div style="display:flex; gap:10px; flex-wrap:wrap">
              <p class="sample-hint">{{rejectionNextStep(SelectedOfferSample)}}</p><button mat-button class="btn-bg-blue" (click)="onSendRejectionEmail(SelectedOfferSample)">Simulate notification</button>

            </div>
          </div>
          }
          @if(ShowCompletedSamples && SelectedOfferSample.IsOfferSample && SelectedOfferSample.WasApproved && !SelectedOfferSample.InventoryCreated){
          <div>
            <h3 style="margin-bottom:10px">Actions</h3>
            <div style="display:flex; gap:10px; flex-wrap:wrap">
              <button mat-button class="btn-bg-green" (click)="OpenOfferSample(SelectedOfferSample)">Create PO</button>
            </div>
          </div>
          }
        </div>
      </fieldset>

      @if(ShowCompletedSamples){
      <fieldset class="rms-fieldset" style="flex:1; min-width:0; margin:0">
        <legend>Cupping results</legend><p class="sample-hint">{{SelectedOfferSample.CuppingNotes || "No cupping notes recorded."}}</p>
        <div style="display:flex; flex-direction:column; width:100%">
          <h3>SCAA Total: {{SelectedOfferSample.SCAATotal ?? "—"}}</h3>
          <rms-data-slider label="Acidity" [min]="6" [max]="10" [step]="0.25" [(ngModel)]="SelectedOfferSample.Acidity" [disabled]="true"></rms-data-slider>
          <rms-data-slider label="Body" [min]="6" [max]="10" [step]="0.25" [(ngModel)]="SelectedOfferSample.Body" [disabled]="true"></rms-data-slider>
          <rms-data-slider label="Sweetness" [min]="6" [max]="10" [step]="0.25" [(ngModel)]="SelectedOfferSample.Sweetness" [disabled]="true"></rms-data-slider>
          <rms-data-slider label="Aftertaste" [min]="6" [max]="10" [step]="0.25" [(ngModel)]="SelectedOfferSample.Aftertaste" [disabled]="true"></rms-data-slider>
          <rms-data-slider label="Overall" [min]="6" [max]="10" [step]="0.25" [(ngModel)]="SelectedOfferSample.Overall" [disabled]="true"></rms-data-slider>
        </div>
      </fieldset>
      }
    </div>
    }
  </div>
</section>
